export default { sha: 'a0fad3b9d9604527eae106534e77d0c128e1751d', buildNumber: 'undefined' }
